import { useLayoutEffect } from "react";

import { ufoEventSignupFormLoad } from "../../../../utils";

export const SignupFormSuccessUFOEvent = () => {
    useLayoutEffect(() => {
        ufoEventSignupFormLoad.success({
            customData: {
                webPlatform: "bxp-ui",
                reactComponent: "DefaultSignupForm",
                isLoggedIn: false
            }
        });
    });
    return null;
};
